export default class specialInterviewManager {
    constructor(param) {
        this.title = document.querySelector('.p-title__text');
        this.clickTarget = document.querySelectorAll('.p-navigation__item');
        this.contents = document.querySelectorAll('.p-title__contents>.title span');
        this.text = document.querySelector('.p-title__contents>.text');
        this.coverText = document.querySelector('.p-title__text>.cover');
        this.navItem = document.querySelectorAll('.p-navigation__item');
        this.navInner = document.querySelector('.p-navigation__inner');
        this.position = [];
        this.interviewNum = document.querySelectorAll('.l-section').length;
        this.speed = 500;

        if(param.userAgent === "pc"){
            TweenMax.set(this.contents,{opacity: 0});
            TweenMax.set([this.text,this.navItem,this.navInner],{opacity: 0});
        }
        this.param = param;
    }
    init(){
        for(let i=0; i<this.clickTarget.length; i++){
            this.clickTarget[i].addEventListener('click',()=>{
                TweenLite.to(window, 1, {
                    scrollTo:'#p-interview0' + (i+1),
                    ease:"Power4.easeOut"
                });
            });
        }


    }

    splash(){
        TweenMax.to(this.coverText,0.6,{
            x:'100%',
            ease: "Power2.easeIn"
        });
        TweenMax.staggerTo(this.contents,0.7,{
            delay:0.6,
            opacity: 1,
            ease: "Power1.easeOut"
        },0.07);
        TweenMax.to(this.text,0.8, {
            delay:1.5,
            opacity: 1,
            scale:1,
            ease: "Power2.easeOut"
        });
        TweenMax.staggerFromTo(this.navItem,1.8,
            {
                delay:1.5,
                y:100
            },
            {
                y:0,
                ease: "Power2.easeOut",
            },0.4);
        TweenMax.staggerTo(this.navItem,0.9, {
            delay:1.5,
            opacity:1,
            ease: "Power2.easeIn",
        },0.4);
        TweenMax.to(this.navInner,0.9, {
            delay:1.5,
            opacity:1,
            ease: "Power2.easeIn",
        });


    }

    resize(){

    }

}